const CardSettingTypes = {
    DIGITAL_CARD: "DIGITAL_CARD",
    INSTANT_CARD: "INSTANT_CARD",
    EMBOSSED_CARD:"EMBOSSED_CARD",
};

export default CardSettingTypes;
